export function createWatermark(
	context: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D,
	text = 'Watermark',
	width = 200,
	height = 100,
	color = '#0000001F',
): void {
	const x = Math.floor(width / 2);
	const y = Math.floor(height / 2);
	context.save();
	context.translate(x, y);
	context.rotate(-Math.PI / 6);
	context.textAlign = 'center';
	context.textBaseline = 'middle';
	context.fillStyle = color;
	let fontSize = 16;
	context.font = `500 ${fontSize}px Arial`;
	while (context.measureText(text).width > width * 0.9 && fontSize > 8) {
		fontSize -= 1;
		context.font = `500 ${fontSize}px Arial`;
	}
	context.fillText(text, 0, 0);
	context.restore();
}
